import { type ReactNode } from "react";

type InputErrorProps = {
  error: ReactNode;
  keepErrorVisible?: boolean;
};

export function InputError({
  error,
  keepErrorVisible = true,
}: InputErrorProps) {
  const isVisible = !!error;

  if (!error && !keepErrorVisible) return null;

  return (
    <div
      className={`h-5 transition-opacity duration-300 ease-in-out ${
        isVisible ? "visible opacity-100" : "invisible opacity-0"
      }`}
    >
      <div className="mt-1 text-sm font-bold text-red-500">{error}</div>
    </div>
  );
}
